export function isCashCustomer(customerNumber: string) {
  return ['200000','200001'].includes(customerNumber);
}
